/** Whether the "you are giving up this pull" warning still shows.
 *
 *  Remembered per browser, because the warning is worth showing once and
 *  becomes an obstacle by the fifth respin -- and respins are now unlimited, so
 *  a player working through a pool hits it repeatedly. Opting out is a decision
 *  the player makes about their own screen, so it lives in their browser rather
 *  than on their account.
 *
 *  A blocked localStorage falls back to SHOWING the warning. If the choice
 *  cannot be stored, the safe default is the one that asks before destroying
 *  what is on screen.
 */
const RESPIN_WARN_KEY = 'br1-packs-skip-respin-warning'

export const respinWarningMuted = (): boolean => {
    try {
        return localStorage.getItem(RESPIN_WARN_KEY) === '1'
    } catch {
        return false
    }
}

export const muteRespinWarning = (muted: boolean) => {
    try {
        localStorage.setItem(RESPIN_WARN_KEY, muted ? '1' : '0')
    } catch {
        /* A browser that refuses to remember it will ask again. */
    }
}

